import React from 'react';
import Typography from '../typography';

const PageTitle: React.FC<React.HTMLProps<HTMLHeadingElement>> = ({ children, as, color, ...props }) => (
    <Typography
        as="h1"
        fontWeight="regular"
        reducedLetterSpacing
        fontSize={{
            dt: '5xl',
            tb: '4xl',
            mb: '3xl',
        }}
        style={{ lineHeight: 1.2 }}
        {...props}
    >
        {children}
    </Typography>
);

export default PageTitle;
